import {
  NO_APPLICATIONS_MESSAGE,
  NO_FAVORITES_MESSAGE,
} from '@/features/applications/constants/applications.constants';
import type { ApplicationFilter } from '@/features/applications/types/applications.types';

export function emptyCatalogMessage(
  filter: ApplicationFilter,
  query: string,
  hasApplicationSearchQuery: boolean
): string {
  if (hasApplicationSearchQuery) {
    return `Nothing matches “${query.trim()}”.`;
  }

  if (filter === 'favorites') {
    return NO_FAVORITES_MESSAGE;
  }

  return NO_APPLICATIONS_MESSAGE;
}
